export const IP_INFO_DB_API_KEY =
  '15c1706b063a0056337acbebd25caeb858ae357e8f810d37d6c5c6ce53a479cd' //https://www.ipinfodb.com/
